import { render } from "./shop-tabs-sec.vue?vue&type=template&id=2a7cb364&scoped=true"
import script from "./shop-tabs-sec.vue?vue&type=script&lang=js"
export * from "./shop-tabs-sec.vue?vue&type=script&lang=js"

import "./shop-tabs-sec.vue?vue&type=style&index=0&id=2a7cb364&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7cb364"]])

export default __exports__